import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import cx from 'clsx';

import * as styles from './styles.css';

interface IHowItWorkLayoutProps extends React.PropsWithChildren {
  title: string;
  className: 'wrapper-3-colum' | 'wrapper-4-colum';
}

export const HowItWorkLayout: React.FC<IHowItWorkLayoutProps> = ({ title, className, children }) => {
  return (
    <section>
      <UIHeading1 as="h2" color="text-primary-default">
        {title}
      </UIHeading1>

      <div className={cx(styles['wrapper'], styles[className])}>{children}</div>
    </section>
  );
};
